import React from 'react';
import { Flex, Box } from '@wegroup/design-system';
import FlowsFormProvider from '../../../../store/context/FlowsFormProvider';
import CompanyScanAppShell from './app-shell/CompanyScanAppShell';
import CompanyScanProgressToolbar from './toolbar/CompanyScanProgressToolbar';
import useElementBounds from '../../../../../../common/src/hooks/useElementBounds';
import CompanyScanBottomBar from './bottom-bar/CompanyScanBottomBar';
import CompanyScanBottomBarDrawer from './bottom-bar-drawer/CompanyScanBottomBarDrawer';
import CompanyScanLayout from './app-shell/CompanyScanLayout';
// import useWrongStructureError from '../hooks/useWrongStructureError';
import ProgressBar from './common/ProgressBar';
import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import ViewOnlyModeHeader from './view-only-mode/ViewOnlyModeHeader';
import useFlowsCurrentTag from '../../../../hooks/useFlowsCurrentTag';

const CompanyScanView: React.FC<React.PropsWithChildren<unknown>> = () => {
  const currentTag = useFlowsCurrentTag();
  const isViewOnlyMode = useFlowsSelector(
    (state) => state.flows.isViewOnlyModeOn,
  );

  // Hook used to avoid wrong usage of this component
  // useWrongStructureError();

  const { setRef, left, width } = useElementBounds();

  return (
    <CompanyScanViewWrapper>
      <Flex flexDir="column" h="100%" overflow="hidden" pos="relative">
        {isViewOnlyMode && (
          <Box pos="sticky" top="0" left={left} width="100%" zIndex="1">
            <ViewOnlyModeHeader />
          </Box>
        )}
        <FlowsFormProvider key={currentTag}>
          {/* Extra padding is used for the progress bar at the bottom */}
          <Flex flexGrow={1} overflow="hidden" pos="relative" pb="1">
            <Box ref={setRef} display={{ base: 'none', tablet: 'block' }}>
              <CompanyScanProgressToolbar />
            </Box>
            <CompanyScanLayout />
          </Flex>
          <CompanyScanBottomBar />
        </FlowsFormProvider>
        <ProgressBar pos="absolute" bottom="72px" left="0" right="0" />
      </Flex>
      <CompanyScanBottomBarDrawer left={left} width={width} />
    </CompanyScanViewWrapper>
  );
};

const CompanyScanViewWrapper: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return <CompanyScanAppShell>{children}</CompanyScanAppShell>;
};

export default CompanyScanView;
